export interface ArrowsValues {
    x: number;
    y: number;
}

export interface ArrowEvent {
    value: number;
    type: TextureTransitionType;
}

export enum ArrowStyle {
    studio = 'studio',
    mosaics = 'mosaics',
}

export enum TextureTransitionType {
    x = 'x',
    y = 'y',
}
